import type { ColumnDef } from '@tanstack/react-table';

import { DataTableColumnHeader } from '@/components/dataTable/ColumnHeader';
import { getSerialNumber } from '@/components/dataTable/data-table.utils';
import { Inquiry } from '@/services/faq/faq.types';

export function getColumns(t: (key: string) => string): ColumnDef<Inquiry>[] {
  return [
    {
      accessorKey: 'sn',
      header: ({ column }) => (
        <DataTableColumnHeader className="whitespace-nowrap" column={column} title={t('common.page.tableColumn.sn')} />
      ),
      cell: ({ row, table }) => <div className="font-medium">{getSerialNumber(table, row.index)}</div>,
      enableSorting: false,
      enableHiding: false,
    },
    {
      accessorKey: 'nickname',
      header: ({ column }) => <DataTableColumnHeader column={column} title={t('faq.complaints.table.nickname')} />,
      cell: ({ row }) => (
        <div className="text-caption font-medium text-primary truncate max-w-[12rem]">{row.getValue('nickname')}</div>
      ),
      enableHiding: false,
    },
    {
      accessorKey: 'phoneNumber',
      header: ({ column }) => <DataTableColumnHeader column={column} title={t('faq.complaints.table.phoneNumber')} />,
      cell: ({ row }) => <div className="text-caption font-medium text-primary">{row.getValue('phoneNumber')}</div>,
      enableHiding: false,
    },
    {
      accessorKey: 'subject',
      header: ({ column }) => <DataTableColumnHeader column={column} title={t('faq.complaints.table.subject')} />,
      cell: ({ row }) => <div className="text-caption font-medium text-primary">{row.getValue('subject')}</div>,
      enableHiding: false,
    },
    {
      accessorKey: 'message',
      header: ({ column }) => <DataTableColumnHeader column={column} title={t('faq.complaints.table.message')} />,
      cell: ({ row }) => (
        <div className="text-caption font-medium text-primary truncate max-w-[30rem]">{row.getValue('message')}</div>
      ),
      enableHiding: false,
    },
    {
      accessorKey: 'createdDate',
      header: ({ column }) => <DataTableColumnHeader column={column} title={t('faq.complaints.table.postedDate')} />,
      cell: ({ row }) => {
        const date = new Date(row.getValue<Date>('postedDate'));
        return <div className="text-caption font-medium text-primary">{date ? date.toLocaleDateString() : '-'}</div>;
      },
      meta: {
        label: 'Created Date',
      },
      enableHiding: false,
      enableColumnFilter: true,
    },
  ];
}
